<template>
    <div>
        <!-- <div class="page-group-title"><span>赠票种类</span></div> -->
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/activity/savePresentTP')" type="primary" icon="el-icon-plus" @click="add"
                size="small" :disabled="haveEditAudit" plain>新增赠票</el-button>
            <el-button v-if="$utils.have('/activity/batchImport')" type="primary" icon="el-icon-upload2"
                @click="$refs.importTicketPrices.show(ticketPrices)" size="small" :disabled="haveEditAudit" plain>按手机号批量发放</el-button>
            <el-button v-if="$utils.have('/activity/batchImportSeat') && data && data.isSeat == 1" type="primary" icon="el-icon-upload2"
                @click="$refs.importTicketPrices.show(ticketPrices, 2)" size="small" :disabled="haveEditAudit" plain>批量生成兑换码</el-button>
			<el-button type="primary" icon="el-icon-upload2"  size="small" :disabled="haveEditAudit" plain v-if="data && data.isShowAllButton ==1 " @click="inviteForm(data)">邀请函总表导入</el-button>
			<el-button type="primary" icon="el-icon-upload2"  size="small" :disabled="haveEditAudit" plain  @click="inviteCode(data)"  :loading="downLoading"
			v-if="canUpload=== 1 && (buyType === 1 && realName === 1) && realNameNo === 1"
			> 下载邀请函核销码按钮</el-button>
        </div>
        <div class="page-list-box">
            <el-table :data="ticketPrices" border style="width: 100%" v-loading="dataLoading" size="small" stripe>
				<el-table-column label="赠票类型" min-width="90">
					<template slot-scope="scope">
						<div>{{scope.row.presentTicketType == 1 ? '邀请函赠票' : '普通赠票'}}</div>
					</template>
				</el-table-column>
                <el-table-column prop="id" label="票品ID" min-width="150"></el-table-column>
                <el-table-column prop="ticketName" label="名称" show-overflow-tooltip></el-table-column>
                <el-table-column label="票品形态" min-width="130">
                    <template slot-scope="scope">                      
						<span v-if="scope.row.electronicType == 1">二维码电子票</span>
						<span v-if="scope.row.electronicType == 2">身份证电子票</span>
                    </template>
				</el-table-column>
				<el-table-column prop="sessionName" label="绑定验票场次" min-width="100" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="presentNum" label="手机号发放" min-width="90"></el-table-column>  
				<el-table-column label="兑换码兑换" min-width="100">
					<template slot-scope="scope">
						<p>生成：{{scope.row.redeemCreateNum}}</p>
						<p>兑换：{{scope.row.redeemGotNum}}</p>						
					</template>
				</el-table-column>                              
                <template v-if="data && data.isSeat == 1">
                    <el-table-column prop="realName" label="是否实名">
                        <template slot-scope="{row} = scope">{{row.realName == 1 ? '实名制' : '非实名制'}}</template> 
                    </el-table-column>
                    <el-table-column prop="totalNum" label="总库存"></el-table-column>
                </template>
                
                <el-table-column v-if="data && data.isSeat == 1" prop="redeemCreateNum" label="已生成兑换码数" min-width="110"></el-table-column>
               
                <el-table-column prop="instruction" label="票品说明" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="!haveEditAudit" fixed="right" label="操作" width="400">
                    <template slot-scope="scope">
                        <el-button v-if="$utils.have('/activity/savePresentTP')" type="text" size="small"
                            @click="edit(scope.row)">编辑</el-button>
                        <template v-if="$utils.have('/activity/sendPresent') && data && data.isSeat != 1">
                            <el-button type="text" size="small" @click="send(scope.row, 1)">按手机号发放</el-button>
                            <el-button type="text" size="small" @click="send(scope.row, 2)">生成兑换码</el-button>
                        </template>
                        <el-button v-if="scope.row.presentTicketType == 1" type="text" size="small"
                         @click="$refs.uploadCode.show(scope.row)">下载二维码</el-button>
						<el-button type="text" size="small" @click="setSeat(scope.row)" v-if="scope.row.sessionIds && scope.row.sessionIds.length == 1 && scope.row.presentTicketType == 1"><span v-if="scope.row.siteFileUrl">管理座位号</span><span v-else>导入座位号 </span></el-button>	
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <new-ticket-prices ref="newTicketPrices" :isSeat="data && data.isSeat" :activityId="activityId" @onUpdate="getDatalist"></new-ticket-prices>
        <send-ticket-prices ref="sendTicketPrices" :activityId="activityId" @onUpdate="getDatalist"></send-ticket-prices>
        <import-ticket-prices ref="importTicketPrices" :isSeat="data && data.isSeat" :activityId="activityId" @onUpdate="getDatalist">
        </import-ticket-prices>
		<import-ticket-seat ref="importTicketSeat" :data="data" :activityId="activityId" @onUpdate="getDatalist"></import-ticket-seat>
		<import-invite-form ref="importInviteForm" :activityId="activityId" :activityName="data && data.activityName" @onUpdate="getDatalist"></import-invite-form>
		<upload-code ref="uploadCode" :data="data" :activityId="activityId" @onUpdate="getDatalist"></upload-code>
    </div>
</template>
<script>
import NewTicketPrices from './ticket-prices-new';
import SendTicketPrices from './ticket-prices-send';
import ImportTicketPrices from './ticket-prices-import';
import ImportTicketSeat from './ticket-prices-seat';
import ImportInviteForm from './import-invite-form';
import UploadCode from './upload-code';
import {downloadFileTmp} from '@/assets/js/commonApi.js';
export default {
    props: {
        activityId: {
            type: [Number, String],
            default: () => null
        },
        haveEditAudit: {
            type: Boolean,
            default: false
        },
        isSeat: {
            type:[Number,String],
            default: 0
        },
		
    },
    components: { NewTicketPrices, SendTicketPrices, ImportTicketPrices,ImportTicketSeat ,UploadCode,ImportInviteForm},
    data() {
        return {
            dataLoading: false,
            ticketPrices: null,
            data: null,
			downLoading:false,
			realNameNo:0,
			canUpload:0,
			realName:'',
			buyType:''
        }
    },
    created() {
        this.getDatalist()
    },
    methods: {
        //获取列表
        getDatalist() {
            this.dataLoading = true;
            this.$request({
                url: "/activity/presentTicketPrices",
                params: { activityId: parseInt(this.activityId) },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = result
                        this.ticketPrices = result.ticketPriceVos;
                        this.$emit('update:activityName', result.activityName);
                        this.$emit('update:haveEditAudit', result.haveEditAudit);											
                        this.$emit('update:isSeat', result.isSeat);
						
						if( this.ticketPrices && this.ticketPrices && this.ticketPrices.length > 0 ){
							this.ticketPrices.forEach((tab, idx) => {
								if( tab.realName == 1 ){
									this.realNameNo = 1
								}
								if( tab.presentTicketType == 1 ){
									this.canUpload = 1
								}					
							})
							var	_data2 = this.ticketPrices.filter(item => item.presentTicketType !== 0 );
							if( _data2.every(x=>x.buyType == 2) ){
								this.buyType = 1
							}else if ( _data2.every(x=>x.buyType == 3) ){
								this.buyType = 1
							}else{
								this.buyType = 0
							}				
							if ( _data2.every(x=>x.realName == 1) ){
								this.realName = 1
							}else if ( _data2.every(x=>x.realName == 0) ){
								this.realName = 1
							}else{
								this.realName = 0
							}
						}
						
                    } else {
                        self.$message.error(msg || "获取票品种类失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取票品种类失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //新增事件
        add() {
            this.$refs.newTicketPrices.show();
        },
        //编辑事件
        edit(data) {
            this.$refs.newTicketPrices.show(data);
        },
        //发放事件
        send(data, type) {
            this.$refs.sendTicketPrices.show(data, type);
        },
		//邀请函总表导入
		inviteForm(data){
			this.$refs.importInviteForm.show(data);
		},
		async inviteCode(){			
			let filePath;
			this.downLoading = true;
			 const res = await this.$request({
				url:'/activity/downloadInviteCode',
				method: 'post',
				params: { activityId: parseInt(this.activityId) },
			})
				.catch(err => {
					this.$message({message: err.message, type: 'error'});
				})
			const{state,msg,result} = res.data;
			if(state == 1 && result){
				filePath = result.url;
			}else{
				this.downLoading = false;
				return this.$message.error(msg || '下载失败');
			}   
			
			downloadFileTmp(filePath,this.activityId + '邀请函核销码.'+this.$utils.getFileType(filePath));
			this.downLoading = false;
		},
		//座位号
		setSeat(data){
			this.$refs.importTicketSeat.show(data);
		},
        updataList() {
            this.getDatalist();
            this.$emit('updateRecordsList');
        },
        
    }
}
</script>